import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementGlacierCreateMutation, useMeasurementGlacierFindAllQuery, useMeasurementGlacierUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import Flatpickr from "react-flatpickr";

const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)
  const { data, error, isFetching } = useMeasurementGlacierFindAllQuery(`?glacier_id=${id}`);
  const [measurementGlacierCreate, measurementGlacierCreateResult] = useMeasurementGlacierCreateMutation();
  const [measurementGlacierUpdate, measurementGlacierUpdateResult] = useMeasurementGlacierUpdateMutation();
  const [measurementGlacier, setMeasurementGlacier] = useState<any>();

  const [is_clean, setIs_cleanBoolean] = useState<boolean>(false);

  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [measurementList, setMeasurementList] = useState<any>();
  const [meaCount, setMeaCount] = useState<any>();


  useEffect(() => {
    if (measurementGlacier === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    setMeasurementList(data?.data);
    setMeaCount(measurementList?.length);

    const tempIs_clean = measurementGlacier !== null ? measurementGlacier?.is_clean : false;
    setIs_cleanBoolean(tempIs_clean);
  }, [measurementGlacier, id, data?.data])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementGlacier?.id,
      glacier_id: measurementGlacier?.glacier_id,
      glacier_code: measurementGlacier?.glacier_code,
      measure_date: measurementGlacier?.measure_date,
      surface_area: measurementGlacier?.surface_area,
      shape: measurementGlacier?.shape,
      average_depth: measurementGlacier?.average_depth,
      maximum_depth: measurementGlacier?.maximum_depth,
      length: measurementGlacier?.length,
      width: measurementGlacier?.width,
      // physical_quality: measurementGlacier?.physical_quality,
      usage_information: measurementGlacier?.usage_information,
      sanitary_requirements: measurementGlacier?.sanitary_requirements,
      report_autor: measurementGlacier?.report_autor,
      report_name: measurementGlacier?.report_name,
      report_code: measurementGlacier?.report_code,


      is_clean: measurementGlacier?.is_clean
    },
    validationSchema: Yup.object({
      glacier_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      surface_area: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      shape: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      average_depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      maximum_depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      width: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      sanitary_requirements: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (measurementGlacier !== null) {
        const updateList = {
          id: measurementGlacier?.id,
          glacier_id: measurementGlacier?.glacier_id,
          glacier_code: values.glacier_code,
          measure_date: values.measure_date,
          surface_area: values.surface_area,
          shape: values.shape,
          average_depth: values.average_depth,
          maximum_depth: values.maximum_depth,
          length: values.length,
          width: values.width,
          // physical_quality: values.physical_quality,
          usage_information: values.usage_information,
          sanitary_requirements: values.sanitary_requirements,
          report_autor: values.report_autor,
          report_name: values.report_name,
          report_code: values.report_code,

          is_clean: is_clean === undefined ? false : is_clean,
        }

        measurementGlacierUpdate(updateList);
      } else {
        const newList = {
          glacier_id: id,
          glacier_code: values["glacier_code"],
          measure_date: values["measure_date"],
          surface_area: values["surface_area"],
          shape: values["shape"],
          average_depth: values["average_depth"],
          maximum_depth: values["maximum_depth"],
          length: values["length"],
          width: values["width"],
          // physical_quality: values["physical_quality"],
          usage_information: values["usage_information"],
          sanitary_requirements: values["sanitary_requirements"],
          report_autor: values["report_autor"],
          report_name: values["report_name"],
          report_code: values["report_code"],

          is_clean: is_clean === undefined ? false : is_clean,
        };

        measurementGlacierCreate(newList)
      }
      validation.resetForm();
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label"
              onClick={() => {
                validation.resetForm();
                setMeasurementGlacier(null);
                setIs_cleanBoolean(false);
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>

          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementGlacier(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Код </Label>
                      <Input
                        name="glacier_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.glacier_code || ""}
                        invalid={
                          validation.touched.glacier_code &&
                            validation.errors.glacier_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.glacier_code &&
                        validation.errors.glacier_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.glacier_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Голын дундаж урсац(хэвгий) </Label>
                      <Input
                        name="shape"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.shape || ""}
                        invalid={
                          validation.touched.shape &&
                            validation.errors.shape
                            ? true
                            : false
                        }
                      />
                      {validation.touched.shape &&
                        validation.errors.shape ? (
                        <FormFeedback type="invalid">
                          {validation.errors.shape}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Дундаж гүн (м)  </Label>
                      <Input
                        name="average_depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.average_depth || ""}
                        invalid={
                          validation.touched.average_depth &&
                            validation.errors.average_depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.average_depth &&
                        validation.errors.average_depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.average_depth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглалтын (хэрэглээний) талаарх мэдээлэл  </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлан зохиогчийн нэр  </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Урт (м) </Label>
                      <Input
                        name="length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.length || ""}
                        invalid={
                          validation.touched.length &&
                            validation.errors.length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.length &&
                        validation.errors.length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Урсгалын хурд (м/с)</Label>
                      <Input
                        name="maximum_depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.maximum_depth || ""}
                        invalid={
                          validation.touched.maximum_depth &&
                            validation.errors.maximum_depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.maximum_depth &&
                        validation.errors.maximum_depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.maximum_depth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ариун цэвэр,эрүүл ахуйн шаардлага хангалт, хамгаалалтын талаарх мэдээлэл   </Label>
                      <Input
                        name="sanitary_requirements"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sanitary_requirements || ""}
                        invalid={
                          validation.touched.sanitary_requirements &&
                            validation.errors.sanitary_requirements
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sanitary_requirements &&
                        validation.errors.sanitary_requirements ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sanitary_requirements}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн нэр </Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>


                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Голын голдрилын дундаж уналт(хэвгий)  </Label>
                      <Input
                        name="surface_area"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.surface_area || ""}
                        invalid={
                          validation.touched.surface_area &&
                            validation.errors.surface_area
                            ? true
                            : false
                        }
                      />
                      {validation.touched.surface_area &&
                        validation.errors.surface_area ? (
                        <FormFeedback type="invalid">
                          {validation.errors.surface_area}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Өргөн (м) </Label>
                      <Input
                        name="width"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.width || ""}
                        invalid={
                          validation.touched.width &&
                            validation.errors.width
                            ? true
                            : false
                        }
                      />
                      {validation.touched.width &&
                        validation.errors.width ? (
                        <FormFeedback type="invalid">
                          {validation.errors.width}
                        </FormFeedback>
                      ) : null}
                    </div>


                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн фондын бүртгэлийн дугаар 	 </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Эрүүл ахуйн шаардлага хангасан эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_cleanBoolean(!is_clean);
                        }}
                        checked={is_clean}
                      />

                    </div>
                  </Col>
                  <Col lg={12} className="d-flex justify-content-center mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>
      </Row>
    </>
  )
}

export default Measurement;